module.exports = __webpack_public_path__ + "static/media/sz.dc2faeb7.svg";